import { IPropertyViewData } from "../property/PropertyViewData";

export interface IInstrumentTypeViewData {
    id: string;
    name: string;
    description: string;
    properties: IPropertyViewData[]
}

export default class InstrumentTypeViewData implements IInstrumentTypeViewData {
    id:string;
    name: string;
    description: string;
    properties: IPropertyViewData[];

    constructor(id:string,name: string, description: string, properties:IPropertyViewData[]) {
        this.id = id;
        this.name = name;
        this.description = description
        this.properties = properties;
    }
} 

const defaultInstrumentTypeData = new InstrumentTypeViewData("","","",[]);
export {defaultInstrumentTypeData};
